'use client'
import { Icon } from '@repo/ui'
import { Alert } from '@repo/ui/icons'

const VaultV2HeroPendingActionsError = () => {
  return (
    <div className="gap-sm flex flex-row items-center">
      <div className="bg-primary/40 flex h-[26px] cursor-default items-center justify-center gap-0.5 rounded-full pr-[10px] pl-[5px]">
        <Icon className="text-muted-foreground/40" icon={<Alert />} />
        <span
          className="text-3xs text-muted-foreground"
          style={{ lineHeight: 'normal', whiteSpace: 'nowrap' }}
        >
          Unable to load pending actions.
        </span>
      </div>
    </div>
  )
}

export default VaultV2HeroPendingActionsError
